export default __webpack_public_path__ + "static/media/case_study_on_shabunda_action_plan.60de084c.jpg";